import React from 'react';
import NotesMainPanel from '../../components/workspace/NotesMainPanel';
import { useDashboardData } from '../../components/DashboardShell';
import { useLocale } from '../../context/LocaleContext';

export default function BonnieInboxes() {
  const { data } = useDashboardData();
  const { t } = useLocale();
  const items = data?.bonnie?.inboxes || [];
  return (
    <NotesMainPanel
      title={t('bonnie.inboxesTitle')}
      subtitle={t('bonnie.inboxesSubtitle')}
      items={items}
      emptyTitle={t('bonnie.inboxesEmpty')}
    />
  );
}
